import React from "react";
import ConfigSection from "../../ConfigSection";

const ClientTypeSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Client Type'
      configType='ClientType'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default ClientTypeSection;
